import { useState, useEffect } from 'react';

function usePageVisibility() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    function updateVisibility() {
      const isDocumentVisible = document.visibilityState === 'visible';
      setIsVisible(isDocumentVisible);
    }

    function handleVisibilityChange() {
      updateVisibility();
    }

    function handleWindowBlur() {
      // It was decided not to make the game pause in blur unless you completely leave the relevant browser tab (ELL-6568).
      // setIsVisible(false);
    }

    function handleWindowFocus() {
      updateVisibility();
    }

    // Listen to visibility changes (tab switches)
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Listen to window blur/focus (app/window switches)
    window.addEventListener('blur', handleWindowBlur);
    window.addEventListener('focus', handleWindowFocus);

    updateVisibility();

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleWindowBlur);
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, []);

  return {
    isVisible,
  };
}

export default usePageVisibility;
